import React from 'react'
import { Divider, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { useHoverOpacity } from '../../../../../../../../hooks/useHoverOpacity'
import cx from 'classnames'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    stat: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    mod: {
      marginLeft: '6px',
      fontSize: '0.9em',
      width: 20,
      height: 20,
      color: theme.palette.mode === 'dark' ? '#c2c2c2' : '#000',
      backgroundColor: theme.palette.mode === 'dark' ? '#313131' : '#d0d0d0',
    },
    red: {
      color: '#eb0014',
    },
    green: {
      color: '#44b700',
    },
  })
)

interface Props {
  name: string
  value: string
}

export const StatItem: React.FC<Props> = ({ name, value }) => {
  const classes = useStyles()
  const { onMouseEnter, onMouseLeave, hoverClass } = useHoverOpacity()

  return (
    <>
      <div
        className={cx(classes.stat, hoverClass)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div>{name}</div>
        <div className={classes.stat}>{value} </div>
      </div>
      <Divider />
    </>
  )
}
